import Modal from "@ui-components/Modal";
import Select from "@ui-components/Select";
import { useState, useContext, useEffect } from "react";
import {
  TerminateModalProps,
  TerminateWorksiteSchema,
  WonWorksiteSchema,
  LostWorksiteSchema,
  IncompleteWorksiteSchema,
  TerminateReasonType,
} from "./types";
import { FormattedMessage, useIntl } from "react-intl";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import { NotificationsContext } from "@ui-components/Notifications";
import Button from "@ui-components/Button";
import { WonWorkflow } from "./modals/won-workflow";
import { LostWorkflow } from "./modals/lost-workflow";
import { IncompleteWorkflow } from "./modals/incomplete-workflow";
import authenticationService from "@services/AuthenticationService";
import GetData from "./data";

export const WorksiteTerminateModal = ({
  closeModal,
  selectedWorksite,
  setSelectedWorksite,
}: TerminateModalProps) => {
  const userData = authenticationService.getUserData();
  const internalUser = userData.flg_internal;

  const intl = useIntl();
  const { terminateReasonOptions } = GetData(intl.formatMessage);

  const [formData, setFormData] = useState<TerminateWorksiteSchema>();
  const [wonWorksiteData, setWonWorksiteData] = useState<WonWorksiteSchema>();
  const [lostWorksiteData, setLostWorksiteData] =
    useState<LostWorksiteSchema>();
  const [incompleteWorksiteData, setIncompleteWorksiteData] =
    useState<IncompleteWorksiteSchema>();

  const [reasonType, setReasonType] = useState<TerminateReasonType>("won");

  const [loading, setLoading] = useState(false);

  const countryApiRequest = useCountryAxiosInstance();
  const { push } = useContext(NotificationsContext);

  useEffect(() => {
    let terminateReason = null;
    switch (reasonType) {
      case "won":
        terminateReason = wonWorksiteData;
        break;
      case "lost":
        terminateReason = lostWorksiteData;
        break;
      case "incomplete":
        terminateReason = incompleteWorksiteData;
        break;
    }
    if (terminateReason) {
      setFormData({
        terminateReason,
        terminateTimestamp: Math.trunc(new Date().getTime() / 1000),
      });
    }
  }, [wonWorksiteData, lostWorksiteData, incompleteWorksiteData]);

  const _onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Send dates and worksite id to the backend
    let _selectedWorksite = { ...selectedWorksite };
    _selectedWorksite.terminated = formData;

    let data = await countryApiRequest.put(
      `/worksites/${_selectedWorksite.id}`,
      _selectedWorksite
    );
    setSelectedWorksite(data);
    push({
      title: intl.formatMessage({ id: "worksite_updated_successfully" }),
      type: "success",
    });
    setLoading(false);
    closeModal();
  };

  //const debug = () => "TerminateWorksiteSchema: " + JSON.stringify(formData);

  return (
    <Modal onExit={closeModal} submitting={loading} fixed>
      <form onSubmit={_onSubmit}>
        <div className="mt-4">
          <Select
            label={intl.formatMessage({
              id: "terminate_reason_label",
              defaultMessage: "Motivo di terminazione",
            })}
            options={terminateReasonOptions}
            value={reasonType}
            onChange={(e) => {
              setReasonType(e.target.value);
            }}
          />
          <div className="my-4">
            {reasonType === "won" && (
              <WonWorkflow
                internalUser={internalUser}
                setWonWorksiteData={setWonWorksiteData}
              />
            )}
            {reasonType === "lost" && (
              <LostWorkflow
                internalUser={internalUser}
                setLostWorksiteData={setLostWorksiteData}
              />
            )}
            {reasonType === "incomplete" && (
              <IncompleteWorkflow
                internalUser={internalUser}
                setIncompleteWorksiteData={setIncompleteWorksiteData}
              />
            )}
          </div>
          <Button
            submitting={loading}
            type="submit"
            className="relative overflow-hidden uppercase justify-center inline-flex items-center px-4 pb-2 pt-1.5 border border-gray-300 text-base font-semibold focus:outline-none active:opacity-70 text-white bg-black-500 border-black-500 hover:bg-am-700  w-full"
          >
            <FormattedMessage id="terminate" defaultMessage="Termina" />
          </Button>
        </div>
      </form>
    </Modal>
  );
};
